export default (sitemap: SitemapBuilder) =>
{
    sitemap.find('[[[System]]]', '[[[Ustawienia]]]').push([
        {
            name: '[[[Sztuczna inteligencja]]]',
            route: 'ai-settings'
        }
    ]);

    sitemap.find('[[[System]]]').before('[[[Monitoring]]]', [
        {
            name: '[[[Asystent AI]]]',
            icon: 'far fa-fw fa-microchip-ai',
            auth: { all: ['AdminPermissions@Ai'], any: [] },
            children: [
                {
                    name: '[[[Logi odpowiedzi chatu AI]]]',
                    route: 'ai-chat-response-logs',
                    children: [
                        {
                            name: '[[[Szczegóły wątku]]]',
                            route: 'ai-chat-response-logs-details',
                            visible: false
                        }
                    ]
                }
            ]
        }
    ]);

    sitemap.before('[[[Repozytorium plików]]]', [
        {
            name: '[[[Narzędzia AI]]]',
            short: '[[[AI]]]',
            icon: 'fal fa-fw fa-microchip-ai',
            namespace: 'Ideo.Core.Common.Application.Permissions.AiTools',
            children: [
                {
                    name: '[[[Czat z narzędziami]]]',
                    icon: 'far fa-fw fa-comments',
                    route: 'aitools-tools-ai-chat',
                    auth: { all: ['ChatPermissions@Access'], any: [] }
                }
            ]
        }
    ]);
};
